//Aqui se defiene las variables para el control y manejo de los input

export const initialForm = {
  dateIni: '',
  dateFin: ''
}

  export const formDetalleTelefonia = {
    dateIni: '',
    dateFin: ''
  };
